
import _ from 'lodash';

const minutes = [`00`, `15`, `30`, `45`];

const formatHour = hour => {
  hour = `${hour}`;
  if (hour.length === 1) { hour = `0${hour}`; }

  return hour;
};

const hours = _.chain(24)
  .times(hour => hour)
  .map(hour => formatHour(hour))
  .map(hour =>
    minutes.map(minute => `${hour}:${minute}`)
  )
  .flatten()
  .value();

export default hours;
